type CsvCell = string | number | null | undefined;

const escapeCsv = (value: CsvCell) => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  if (str.includes('"') || str.includes(",") || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const exportToCsv = (
  filename: string,
  headers: string[],
  rows: CsvCell[][]
) => {
  const csv = [
    headers.map(escapeCsv).join(","),
    ...rows.map((row) => row.map(escapeCsv).join(",")),
  ].join("\n");

  const blob = new Blob([`\ufeff${csv}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export const downloadChartImage = (chart: { toBase64Image: () => string } | null, filename: string) => {
  if (!chart) return;
  const url = chart.toBase64Image();
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
};

/** Export one or more chart canvases from a container to a single PNG */
export const exportChartsFromContainer = (
  containerRef: { current: HTMLDivElement | null },
  filename: string
) => {
  const container = containerRef.current;
  if (!container) return;
  const canvases = Array.from(container.querySelectorAll("canvas"));
  if (canvases.length === 0) return;

  const drawCanvasOnWhite = (canvas: HTMLCanvasElement): HTMLCanvasElement => {
    const out = document.createElement("canvas");
    out.width = canvas.width;
    out.height = canvas.height;
    const ctx = out.getContext("2d");
    if (!ctx) return canvas;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, out.width, out.height);
    ctx.drawImage(canvas, 0, 0);
    return out;
  };

  if (canvases.length === 1) {
    const output = drawCanvasOnWhite(canvases[0]);
    const link = document.createElement("a");
    link.download = `${filename}.png`;
    link.href = output.toDataURL("image/png");
    link.click();
    return;
  }

  const gap = 24;
  const width = Math.max(...canvases.map((c) => c.width));
  const height = canvases.reduce((acc, c) => acc + c.height, 0) + gap * (canvases.length - 1);
  const output = document.createElement("canvas");
  output.width = width;
  output.height = height;
  const ctx = output.getContext("2d");
  if (!ctx) return;
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, width, height);
  let y = 0;
  for (const c of canvases) {
    ctx.drawImage(c, 0, y, c.width, c.height);
    y += c.height + gap;
  }
  const link = document.createElement("a");
  link.download = `${filename}.png`;
  link.href = output.toDataURL("image/png");
  link.click();
};
